/*
 * use-device-orientation
 */
import { useState } from "react"
import { useEventListener } from "./use-event-listener"

export type OrientationState = {
	gamma: number
	beta: number
	alpha: number
}

export function useDeviceOrientation(): OrientationState | null {
	const [rotation, setRotation] = useState<OrientationState | null>(null)

	function onOrientationChange({ gamma, beta, alpha }: any) {
		if (gamma === null) {
			return
		}
		setRotation({ gamma, beta, alpha })
	}

	useEventListener("deviceorientation", onOrientationChange)

	return rotation
}
